export default __webpack_public_path__ + "static/media/explore-my-cover.907207b1.svg";